import _ from 'lodash';

/**
 *
 * @param a
 * @param b
 * @returns {number}
 */
export const sortByPosition = (a, b) => {
  if (a.position < b.position) {
    return -1;
  }
  if (a.position > b.position) {
    return 1;
  }
  return 0;
}

export const getOptions = (startCounts) => {
  if (startCounts) {
    return startCounts
      .filter((count) => count.refill)
      .map((count) => ({
        ...count,
        label: count.name,
        value: count.refill_count_id,
      }))
      .reduce((options, option) => {
        const findGroupIndex = options.findIndex((item) => item.label === option.network);
        const selectOption = {
          ...option,
          label: option.name,
          value: option.value,
        };
        if (findGroupIndex === -1) {
          options.push({
            label: option.network,
            position: option.position_network,
            options: [selectOption],
          })
        } else {
          options[findGroupIndex].options.push(selectOption)
          options[findGroupIndex].options = options[findGroupIndex].options.sort(sortByPosition)
        }
        return options;
      }, [])
      .sort(sortByPosition)
  }
  return []
};

export const getSelectedValue = (options, startCountSelected) => {
  if (_.isArray(options)) {
    const findOption = options.find((option) => option.refill_count_id !== null && option.refill_count_id === startCountSelected);
    if (findOption) {
      return {
        label: findOption.name,
        value: findOption.refill_count_id,
      }
    }
    return null;
  }
  return new Error(`option not valid, ${typeof options}`);
};
